import { loadModules } from 'esri-loader';
import { IBSLALayerProps } from '../BSLALayers';
import BSLAConsEaseLayers from './BSLAConsEaseLayers';
import BSLAParcelLayer from './BSLAParcelLayer';
import BSLAFloodLayer from './BSLAFloodLayer';
import { BSLAFDEPERPPermitsLayer, BSLAWMDERPPermitsLayer } from './BSLAERPPermitsLayer';
import BSLASortLayers from '../../helpers/BSLASortLayers';
import BSLAGypsumStackLayer from './BSLAGypsumStacksLayer';
import BSLAMesicHammockLayer from './BSLAMesicHammockLayer';
import BSLASinkholesLayer from './BSLASinkholesLayer';
import BSLAOilGasLayer from './BSLAOilGasLayer';
import { LAND_CHAR_TITLE } from '../../BSLAConstants';

const BSLALandCharLayers = async (props: IBSLALayerProps) => {
    if (props.view) {
        const layers = [];

        const parcelsLayer = await BSLAParcelLayer(props.view);
        if (parcelsLayer) {
            layers.push(parcelsLayer);
        }

        const floodLayer = await BSLAFloodLayer();
        if (floodLayer) {
            layers.push(floodLayer);
        }

        const conservationEasementsLayer = await BSLAConsEaseLayers();
        if (conservationEasementsLayer) {
            layers.push(conservationEasementsLayer);
        }

        const erpPermitsLayer = await BSLAFDEPERPPermitsLayer();
        if (erpPermitsLayer) {
            layers.push(erpPermitsLayer);
        }

        const erpWMDPermitsLayer = await BSLAWMDERPPermitsLayer();
        if (erpWMDPermitsLayer) {
            layers.push(erpWMDPermitsLayer);
        }

        const gypsumStackLayer = await BSLAGypsumStackLayer();
        if (gypsumStackLayer) {
            layers.push(gypsumStackLayer);
        }

        const mesicHammockLayer = await BSLAMesicHammockLayer();
        if (mesicHammockLayer) {
            layers.push(mesicHammockLayer);
        }

        const sinkholesLayer = await BSLASinkholesLayer();
        if (sinkholesLayer) {
            layers.push(sinkholesLayer);
        }

        const oilGasLayer = await BSLAOilGasLayer();
        if (oilGasLayer) {
            layers.push(oilGasLayer);
        }

        type layerModules = [typeof import('esri/layers/GroupLayer')];

        const [GroupLayer] = await (loadModules(['esri/layers/GroupLayer']) as Promise<layerModules>);

        return new GroupLayer({
            title: LAND_CHAR_TITLE,
            layers: layers.sort(BSLASortLayers)
        });
    }
};

export default BSLALandCharLayers;
